import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/stt-video-2.webp")